export const APP_OPTIONS = [
	{ label: "Moments", value: "1" },
	{ label: "IKCATI", value: "2" },
];

export const PLATFORM_OPTIONS = [
	{ label: "IOS", value: "IOS" },
	{ label: "Android", value: "ANDROID" },
	{ label: "Huawei", value: "HUAWEI" },
];

export const FORCE_UPDATE_OPTIONS = [
	{ label: "Açık", value: "true" },
	{ label: "Kapalı", value: "false" },
];